import { Injectable } from '@angular/core';
import { LessonsFilter } from '../content/lessons-filter';
import { HttpParams } from '@angular/common/http';
import { YeshivaEnums } from 'src/serverTypes/yeshivaTypesEnums';
//import { AngularApp } from '../serverTypes/yeshivaTypes';

@Injectable()
export class BackenAccessService {
    public filterToAPIParameters(lessonsFilter: LessonsFilter | null): HttpParams {
        let params = new HttpParams();
        if (lessonsFilter) {
            //category ID
            if (lessonsFilter.catId && lessonsFilter.catId > 0) {
                //for catId == 0 use all categories
                params = params.set('catid', String(lessonsFilter.catId));
            }
            if (lessonsFilter.filtMaxLength !== undefined && lessonsFilter.filtMinLength !== undefined && String(lessonsFilter.filtMinLength) !== '0') {
                params = params.set('maxlength', String(lessonsFilter.filtMaxLength));
                params = params.set('minlength', String(lessonsFilter.filtMinLength));
            } else if (lessonsFilter.filtMaxLength !== undefined) {
                params = params.set('maxlength', String(lessonsFilter.filtMaxLength));
                params = params.set('minlength', String(1));
            } else if (lessonsFilter.filtMinLength !== undefined) {
                params = params.set('maxlength', String(256));
                params = params.set('minlength', String(lessonsFilter.filtMinLength));
            }
            if (lessonsFilter.order !== null) {
                params = params.set('order', String(lessonsFilter.order));
            }
            if (lessonsFilter.orderBy !== null) {
                params = params.set('orderby', String(lessonsFilter.orderBy));
            }
            //mediaTypes
            let mediaTypes: YeshivaEnums.AngularApp.API.enums.MediaType = YeshivaEnums.AngularApp.API.enums.MediaType.None;
            if (lessonsFilter.filtVideo) {
                mediaTypes = mediaTypes | YeshivaEnums.AngularApp.API.enums.MediaType.Video;
            }
            if (lessonsFilter.filtAudio) {
                mediaTypes = mediaTypes | YeshivaEnums.AngularApp.API.enums.MediaType.Audio;
            }
            if (lessonsFilter.filtTxt) {
                mediaTypes = mediaTypes | YeshivaEnums.AngularApp.API.enums.MediaType.Text;
            }
            if (lessonsFilter.filtPDF) {
                mediaTypes = mediaTypes | YeshivaEnums.AngularApp.API.enums.MediaType.PDF;
            }
            if (lessonsFilter.filtDoc) {
                mediaTypes = mediaTypes | YeshivaEnums.AngularApp.API.enums.MediaType.Doc;
            }
            params = params.set('mediatypes', String(mediaTypes));

            //contentType
            let contentType: YeshivaEnums.AngularApp.API.enums.ContentType = YeshivaEnums.AngularApp.API.enums.ContentType.All;

            if (lessonsFilter.filtWomanLesson) {
                contentType = contentType | YeshivaEnums.AngularApp.API.enums.ContentType.Woman;
            }
            if (lessonsFilter.filtGeneralLesson) {
                contentType = contentType | YeshivaEnums.AngularApp.API.enums.ContentType.General;
            }
            if (lessonsFilter.filtChildLesson) {
                contentType = contentType | YeshivaEnums.AngularApp.API.enums.ContentType.Children;
            }
            params = params.set('target_audience', String(contentType));

            //rabbis
            if (lessonsFilter.filtRabbis.length > 0 && !(lessonsFilter.filtRabbis.length == 1 && lessonsFilter.filtRabbis[0] == -1)) {
                //-1 in rabbis used to enforce fix filter of all rabbis
                params = params.set('rabbis', lessonsFilter.filtRabbis.join(','));
            }
            //search
            // TODO: Add safe, URL encoded search parameter if there is a search term
            if (lessonsFilter.searchTerm && lessonsFilter.searchTerm.length > 0) {
                params = params.set('search', lessonsFilter.searchTerm);
            }
        }
        return params;
    }
}
